import { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import * as React from 'react';

export const TabLabel = (props: PropsWithChildren<{label?: number | string, color?: string}>) => (
  <Box component={'span'} position={'relative'}>
    {props.children}
    {!!props.label && <Typography position={'absolute'} noWrap left={'calc(100% + 5px)'} top={0} fontWeight={500} fontSize={10} lineHeight={1} color={props.color || 'inherit'}>
      {props.label}
    </Typography>}
  </Box>
)
